import IntegracaoMercadoLivreService from "@/services/IntegracaoMercadoLivreService";

export const integracaoMercadoLivre = {
  namespaced: true,
  state: {},
  actions: {
    getAuthorizationUrl({ commit }) {
      return IntegracaoMercadoLivreService.GetAuthorizationUrl().then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    exchangeCode({ commit }, payload) {
      return IntegracaoMercadoLivreService.ExchangeCode(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    searchCategories({ commit }, query) {
      return IntegracaoMercadoLivreService.SearchCategories(query).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    getPresetByCategory({ commit }, categoryId) {
      return IntegracaoMercadoLivreService.GetPresetByCategory(categoryId).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    getGridSchema({ commit }, payload) {
      return IntegracaoMercadoLivreService.GetGridSchema(
        payload?.categoryId,
        payload
      ).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    exportProducts({ commit }, payload) {
      return IntegracaoMercadoLivreService.ExportProducts(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    importProducts({ commit }) {
      return IntegracaoMercadoLivreService.ImportProducts().then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    importOrders({ commit }, payload) {
      return IntegracaoMercadoLivreService.ImportOrders(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    refreshToken({ commit }) {
      return IntegracaoMercadoLivreService.RefreshToken().then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    disconnect({ commit }) {
      return IntegracaoMercadoLivreService.Disconnect().then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default integracaoMercadoLivre;
